import {Injectable} from '@angular/core';
import {AppLauncher} from '@capacitor/app-launcher';
import {Browser} from '@capacitor/browser';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  async open(url: string) {
    try {
      await Browser.open({url});
    } catch (e) {
      console.warn('Falling back to window.open for url', url, e);
      window.open(url, '_system');
    }
  }

  async openExternal(url: string) {
    try {
      const {completed} = await AppLauncher.openUrl({url});
      if (!completed) {
        throw new Error('No application could open the URL');
      }
    } catch (e) {
      console.warn('Falling back to the in-app browser for url', url, e);
      await this.open(url);
    }
  }
}
